import { Box, Typography, Button } from "@mui/material";
import { assetIcons } from "../../../constants/assets";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import InlineSvg from "../inline-svg";
import { useUser } from "../../../context/user-context";

export default function PaymentMethod({ isMediumScreen }) {
  const { user, updateUser } = useUser();

  return (
    <Box
      sx={{
        borderRadius: "12px",
        boxShadow: "-2px 100px 50px 10px rgba(199, 113, 40, 0.5)",
      }}
    >
      <Typography
        sx={{
          color: "white",
          mb: 2,
          mt: 1,
          fontSize: fontSizes.heading3,
          fontWeight: 700,
        }}
      >
        Payment Method
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: darkColors.background,
          padding: "12px",
          borderRadius: "12px",
          border: `1px solid ${darkColors.borderGray}`,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* <Box
            width={65}
            height={30}
            bgcolor="white"
            borderRadius="4px"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <InlineSvg url={assetIcons.visa} />
          </Box> */}
          <Typography
            sx={{
              color: "white",
              fontSize: fontSizes.heading3,
              fontWeight: 700,
            }}
          >
            {isMediumScreen ? "Ending" : "Wallet Ending"}{" "}
            {user.wallet?.address ? user.wallet.address.slice(-4) : ""}
          </Typography>
        </Box>
        {/* <Button
          sx={{
            color: darkColors.buttonTop,
            fontSize: fontSizes.heading3,
            fontWeight: 700,
          }}
        >
          CHANGE
        </Button> */}
      </Box>
    </Box>
  );
}
